// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './routers'
// src/main.js
import './assets/tailwind.css'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import AppPagination from '@/components/AppPagination.vue'

// Set the document title
document.title = 'Uslu Lojistik'

const app = createApp(App)

app.use(Toast);
import { useToast } from "vue-toastification";
app.config.globalProperties.$toast = useToast();

app.component('AppPagination', AppPagination);

app.use(router)
app.mount('#app')
